import { Route, Routes } from "react-router-dom";
import HomePage from "../pages/Home";
import CategoriesPage from "../pages/Categories";
import { PermissionRoute } from "../../../routes/PermissionRoute";
import ProductsPage from "../pages/Products";
import CreateProductPage from "../pages/Products/create";
import ViewProductPage from "../pages/Products/view";
import StockMovementsPage from "../pages/Stocks";
import AdjustmentsPage from "../pages/Adjustments";
import CreateAdjustmentsPage from "../pages/Adjustments/create";
import WarehousesPage from "../pages/Warehouses";
import TransfersPage from "../pages/Transfers";
import CreateTransferPage from "../pages/Transfers/create";
import ViewTransferPage from "../pages/Transfers/view";

export default function InventoryRoutes() {
  return(
    <Routes>
      <Route element={<PermissionRoute permission="inventory.home" />}>
        <Route path="home" element={<HomePage />} />
      </Route>

      <Route element={<PermissionRoute permission="inventory.categories.view" />}>
        <Route path="categories">
          <Route path="" element={<CategoriesPage />} />
        </Route>
      </Route>

      <Route element={<PermissionRoute permission="inventory.warehouses.view" />}>
        <Route path="warehouses">
          <Route path="" element={<WarehousesPage />} />
        </Route>
      </Route>

      <Route element={<PermissionRoute permission="inventory.products.view" />}>
        <Route path="products">
          <Route path="" element={<ProductsPage />} />
          <Route path="create" element={<CreateProductPage />} />
          <Route path="view/:id" element={<ViewProductPage />} />
          <Route path="edit/:id" element={<CreateProductPage />} />
        </Route>
      </Route>

      <Route element={<PermissionRoute permission="inventory.stock_movements.view" />}>
        <Route path="stock-movements">
          <Route path="" element={<StockMovementsPage />} />
        </Route>
      </Route>

      <Route element={<PermissionRoute permission="inventory.transfers.view" />}>
        <Route path="stock-transfers">
          <Route path="" element={<TransfersPage />} />
          <Route path="create" element={<CreateTransferPage />} />
          <Route path="view/:id" element={<ViewTransferPage />} />
        </Route>
      </Route>

      <Route element={<PermissionRoute permission="inventory.stock_adjustments.view" />}>
        <Route path="stock-adjustments">
          <Route path="" element={<AdjustmentsPage />} />
          <Route path="create" element={<CreateAdjustmentsPage />} />
        </Route>
      </Route>
    </Routes>
  );
}